export { FaqSection } from './faq'
